import { useEffect } from 'react';
import { useSelector } from 'react-redux';

/**
 * Reflect the stored theme and palette onto `<html>`, which is what both
 * stylesheets select on: design.css keys dark mode to `[data-theme="dark"]`,
 * marketing.css keys light mode to its absence.
 *
 * Called from the route table, not the app shell — the marketing and auth
 * screens render outside that shell and answer to the same setting.
 */
export function useDocumentTheme() {
  const { theme, palette } = useSelector((s) => s.ui);
  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') root.setAttribute('data-theme', 'dark');
    else root.removeAttribute('data-theme');
    root.setAttribute('data-palette', palette);
  }, [theme, palette]);
}
